var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 112,
    viewBox: "0 0 101 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8059 5.66632H16.8333V8.5C16.8333 13.1941 20.6019 17 25.25 17H75.75C80.3991 17 84.1667 13.1941 84.1667 8.5V5.66632H98.1951C99.7445 5.66632 101 4.39838 101 2.83368C101 1.26898 99.7445 0 98.1951 0H2.8059C1.25654 0 0 1.26898 0 2.83368C0 4.39838 1.25654 5.66632 2.8059 5.66632Z",
    fill: "#40336F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67C51.708 67 52.3857 66.7176 52.8867 66.2137C53.3867 65.7089 53.667 65.0259 53.667 64.3125V61.1309C56.8545 59.9992 58.9902 56.9693 59 53.5643V50C57.2754 50.555 55.4775 50.8502 53.667 50.8768H48.334C46.5225 50.8502 44.7256 50.555 43 50V53.5643C43.0107 56.9693 45.1465 59.9992 48.334 61.1309V64.3125C48.333 65.0259 48.6143 65.7089 49.1143 66.2137C49.6143 66.7176 50.293 67 51 67Z",
    fill: "#40336F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1951 106.428H8.41667C6.86731 106.428 5.6118 105.181 5.6118 103.643C5.6118 102.105 6.86731 100.857 8.41667 100.857H81.3618C86.0099 100.857 89.7785 97.1151 89.7785 92.5C89.7785 87.8849 86.0099 84.143 81.3618 84.143H56.1118C54.5624 84.143 53.3059 82.8954 53.3059 81.357V75.786C53.3059 74.2476 52.0494 73 50.5 73C48.9506 73 47.6951 74.2476 47.6951 75.786V81.357C47.6951 85.9731 51.4627 89.714 56.1118 89.714H81.3618C82.9112 89.714 84.1667 90.9616 84.1667 92.5C84.1667 94.0384 82.9112 95.286 81.3618 95.286H8.41667C3.7686 95.286 0 99.0269 0 103.643C0 108.258 3.7686 112 8.41667 112H98.1951C99.7445 112 101 110.752 101 109.214C101 107.676 99.7445 106.428 98.1951 106.428Z",
    fill: "#F1805E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30.6247V22H34V30.6247C34 38.5641 40.1563 45 47.7507 45H53.2503C60.8447 45 67 38.5641 67 30.6247Z",
    fill: "#40336F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter3D);
export default __webpack_public_path__ + "static/media/printer_3d.c27d588e9208e8b6aef929d884a6599b.svg";
export { ForwardRef as ReactComponent };